import { getTypedTools, SagaContext as UntypedSagaContext } from 'async-saga'
import { RootState } from '../types'
export const { take, takeEvery, waitForState } = getTypedTools<RootState>()
export type SagaContext = UntypedSagaContext<RootState>
